<template>
  <div>
    <div
      v-for="[color, background, fontSize, fontWeight, radius] in classes"
      :key="color"
    >
      <v-btn
        :text="textBtn"
        style="letter-spacing:normal !important;"
        class="cursor-pointer px-1 disabled"
        :style="
          `height: ${height}px  !important; width: ${
            width.includes('%') ? width : width + `px`
          } !important;`
        "
        :class="[
          color,
          background,
          fontSize,
          fontWeight,
          radius,
          disabled ? 'disable-events' : '',
        ]"
        @click="$emit('click')"
        small
        :loading="loading"
      >
        <div
          class="d-flex  align-center "
          :class="pic ? 'justify-center' : 'justify-center'"
          style="width: 90%;"
        >
          <img
            v-if="pic"
            :src="pic"
            alt="pic"
            class="mr-1"
            :width="picSize || '32'"
            :height="picSize || '32'"
          />
          <div style="letter-spacing:normal !important;">
            <v-icon v-if="icon" aria-hidden="false" :size="`${iconSize}px`">
              {{ icon }}
            </v-icon>
            {{ text }}
            <v-icon
              v-if="iconRightText"
              aria-hidden="false"
              :size="`${iconRightTextSize}px`"
            >
              {{ iconRightText }}
            </v-icon>
          </div>
        </div>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    regular: { type: Boolean, default: false },
    medium: { type: Boolean, default: false },
    semiBold: { type: Boolean, default: false },
    bold: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    textBtn: { type: Boolean, textBtn: false },

    height: { type: String, default: "" },
    width: { type: String, default: "" },
    pic: { type: String, default: "" },
    picSize: { type: String, default: "" },

    radius: { type: String, default: "" },
    text: { type: String, default: "" },
    icon: { type: String, default: "" },
    iconSize: { type: String, default: "15" },
    iconRightText: { type: String, default: "" },
    iconRightTextSize: { type: String, default: "15" },
    color: { type: String, default: "" },
    background: { type: String, default: "" },
    fontSize: { type: String, default: "" },

    yellow: { type: Boolean, default: false },
    white: { type: Boolean, default: false },
    whiteBorderRed: { type: Boolean, default: false },
    blue: { type: Boolean, default: false },
    green: { type: Boolean, default: false },
    green1: { type: Boolean, default: false },
    btnDopa: { type: Boolean, default: false },
    search: { type: Boolean, default: false },
    none_: { type: Boolean, default: false },
    btnUploadForm: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      classes: [],
    };
  },
  watch: {
    blue: {
      deep: true,
      immediate: true,
      async handler(props, oldprops) {
        if (oldprops) {
          this.setup();
        }
      },
    },
    none_: {
      deep: true,
      immediate: true,
      async handler(props, oldprops) {
        if (oldprops) {
          this.setup();
        }
      },
    },
  },
  async mounted() {
    this.setup();
  },
  methods: {
    setup() {
      // class สี อยู่ที่ file appPhase2.scss ทั้งหมด ไปเรียกใช้ที่ันั้น
      let color;
      let background;
      let fontSize;
      let fontWeight;
      let radius;

      // class สี อยู่ที่ file appPhase2.scss ทั้งหมด ไปเรียกใช้ที่ันั้น
      if (this.yellow) {
        color = "darkBlue";
        background = "bg-btn-yellow";
      } else if (this.blue) {
        color = "color-white";
        background = "bg-btn-Blue";
      } else if (this.white) {
        color = "darkBlue ";
        background = "bg-btn-white";
      } else if (this.green) {
        color = "color-white";
        background = "bg-btn-green";
      } else if (this.green1) {
        color = "color-white";
        background = "bg-btn-green1";
      } else if (this.btnDopa) {
        background = "bg-btn-D-dopa ";
      } else if (this.none_) {
        color = "darkBlue";
        background = "";
      } else if (this.btnUploadForm) {
        background = "bg-btn-UploadForm ";
      } else if (this.whiteBorderRed) {
        color = "errors";
        background = "bg-btn-white-borderRed ";
      }

      // class  อยู่ที่ file appPhase2.scss ทั้งหมด ไปเรียกใช้ที่ันั้น
      if (this.bold) {
        fontWeight = "bold";
      } else if (this.semiBold) {
        fontWeight = "semiBold";
      } else if (this.medium) {
        fontWeight = "medium";
      } else {
        fontWeight = "regular";
      }

      if (this.color) {
        color = this.color;
      }
      if (this.background) {
        background = this.background;
      }
      if (this.fontSize) {
        fontSize = `fs${this.fontSize}`;
      } else {
        fontSize = "fs14";
      }

      if (this.radius) {
        radius = `radius-${this.radius}`;
      } else {
        radius = "radius-25";
      }
      this.classes = [
        [
          `${color}`,
          `${background}`,
          `${fontSize}`,
          `${fontWeight}`,
          `${radius}`,
        ],
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.disable-events {
  pointer-events: none;
  opacity: 0.4;
}
</style>
